<template>

  <g class="segmented-ring" :id="id?'ring-'+id:'ring-'+ringIndex" :class="id" :data-active="allowHover" :data-fill="segmentFill" >

    <g :transform="startAngle?`rotate(${startAngle},50,50)`:''">
      <g v-for="(segment,segIndex) in paths.nodes" :key="segIndex" class="segment" :ref="ringIndex+'_'+segIndex" :data-active="(selectedIndex === segment.id)">

        <path class="tab path" :d="segment.d"
              :fill="segmentFill" :stroke="strokeColor" :stroke-width="strokeWidth" @click="segmentClickHandler(segment.id)" fill-rule="evenodd"></path>

        <defs>
          <path class="text-path" :d="segment.textPath"
                fill="none" :stroke-width="strokeWidth" :id="segment.textPathId" ></path>
        </defs>

        <text dy="1.0"  :fill="textColor" :font-size="fontSize" class="tab text" pointer-events="none" style="user-select: none;">
          <textPath :xlink:href="'#'+segment.textPathId" startOffset="50%" text-anchor="middle" >
            {{ segment.label }}
          </textPath>
        </text>
      </g>
    </g>

<!--    <g>-->
<!--      <path v-for="(textPath, index) in paths.textPaths" :key="index" :d="textPath" :id="index" stroke="#cc0000"></path>-->
<!--    </g>-->
  </g>

</template>

<script>
export default {
  name: "SegmentedRing",
  mounted() {
    //console.log(this.nodes,this.value)
  },
  props: {

    id: {
      default: function(){
        return ""
      }
    },
    allowHover: {
      default: function(){
        return false
      }
    },

    selectedIndex: {
      default: function(){
        return ""
      }
    },

    ringIndex: {
      default: function(){
        return 0
      }
    },

    origin: {
      default: function(){
        return {
          x: 50,
          y: 50
        }
      }
    },

    innerRadius: {
      default: function(){
        return 10
      }
    },
    outerRadius: {
      default: function(){
        return 20
      }
    },
    startAngle: {
      default: function(){
        return 0
      }
    },
    startSegment: {
      default: function(){
        return 0
      }
    },
    strokeWidth: {
      default: function(){
        return 0.5
      }
    },

    strokeColor: {
      default: function(){
        return "#000"
      }
    },
    segmentFill: {
      default: function(){
        return "#888"
      }
    },

    fontSize: {
      default: function(){
        return 2.0
      }
    },

    textColor: {
      default: function(){
        return "#fff"
      }
    },

    sections: {
      default: function(){
        return [
          {label: "Oncology", size: 1},
          {label: "Cardiology", size: 1},
          {label: "MSK", size: 1},
          {label: "Neurology", size: 1},
          {label: "Women's Health", size: 1}

        ]
      }
    },

    nodes: {
      default: function(){
        return []
      }
    },
    segments: {
      default: function(){
        return [];
      }
    },
    value: {
      default: function(){
        return null
      }
    },
    wheel: {
      default: function(){
        return null
      }
    },
    onSegmentClick: {
      default: function(){
        return ()=>{
          //console.log("segment click",e)
        }
      }
    }
  },
  methods: {

    segmentClickHandler: function(id){
      //console.log(id);

      this.onSegmentClick(id)



    },

    getTotalWeight: function(segments){
      //used to calculate relative slize size weights (size 2.0 is 2x the size of other slices)

      let totalWeight = segments.reduce((total, category) =>{
        let categorySize = category.segments.reduce((subtotal,segment) => {
          let segmentSize = segment.size?segment.size:1;
          return (subtotal + segmentSize);
        },0)
        return (total + categorySize)
      },0)

      return totalWeight;
    },
    donutPath: function(origin, rInner, rOuter){

      //console.log("donutPath",origin, rInner, rOuter, startAngle, sweep);
      //two circles with even odd fills
      //circle path:
      // M(Cx-R),Cy
      // a R,R 0 1,1 (R*2),0
      // a R,R 0 1,1 -(R*2),0

      //let radius1 = rInner;
      let d = `

      M ${origin.x - rOuter}, ${origin.y}
      a ${rOuter}, ${rOuter} 0 1,1 ${rOuter * 2}, 0
      a ${rOuter}, ${rOuter} 0 1,1 -${rOuter * 2}, 0
      M ${origin.x - rInner}, ${origin.y}
      a ${rInner}, ${rInner} 0 1,1 ${rInner * 2}, 0
      a ${rInner}, ${rInner} 0 1,1 -${rInner * 2}, 0
      `

      return d;

    },
    circlePathSingle: function(origin, radius){

      //console.log(startAngle)

      let d = `

      M ${origin.x - radius}, ${origin.y}
      a ${radius}, ${radius} 0 1,0 ${radius * 2}, 0
      a ${radius}, ${radius} 0 1,0 -${radius * 2}, 0

      `
      return d;

    },

    circlePath: function(origin, rInner, rOuter, startAngle, sweep){

      //console.log("circlePath",origin, rInner, rOuter, startAngle, sweep);

      //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
      var A1, A2, A3, A4;

      A1 = this.arcPos(origin, rInner, startAngle);
      A2 = this.arcPos(origin, rOuter, startAngle);
      A3 = this.arcPos(origin, rOuter, startAngle + sweep);
      A4 = this.arcPos(origin, rInner, startAngle + sweep);

      let rotation = 0;
      let arcFlag = 0;



      var d = "M"+A1.x + ","+A1.y;
      d += " L"+A2.x + ","+A2.y;
      d += `A${rOuter},${rOuter} ${rotation} ${arcFlag},1 ${A3.x},${A3.y}`;
      d += " L"+A4.x + ","+A4.y;
      d += `A${rInner},${rInner} ${rotation} ${arcFlag},0 ${A1.x},${A1.y}`;
      d += " Z";
      //console.log(d);
      return d;

    },
    arcSlice: function(origin, rInner, rOuter, startAngle, sweep){


      //console.log("arcSlice",origin, rInner, rOuter, startAngle, sweep);

      //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
      var A1, A2, A3, A4;

      A1 = this.arcPos(origin, rInner, startAngle);
      A2 = this.arcPos(origin, rOuter, startAngle);
      A3 = this.arcPos(origin, rOuter, startAngle + sweep);
      A4 = this.arcPos(origin, rInner, startAngle + sweep);

      let rotation = 0;
      let arcFlag = 0;



      var d = "M"+A1.x + ","+A1.y;
      d += " L"+A2.x + ","+A2.y;
      d += `A${rOuter},${rOuter} ${rotation} ${arcFlag},1 ${A3.x},${A3.y}`;
      d += " L"+A4.x + ","+A4.y;
      d += `A${rInner},${rInner} ${rotation} ${arcFlag},0 ${A1.x},${A1.y}`;
      d += " Z";
      ////console.log(d);
      return d;

    },
    arc: function(origin, rInner, rOuter, startAngle, sweep, flip){

      let baseline = rInner + (rOuter - rInner)/2;

      //console.log("textPath", origin, rInner, rOuter, startAngle, sweep, baseline);

      //console.log("textPath", rInner, rOuter, baseline);

      //var d = "M275,175 v-100 a100,100 0 0,1 100,100 z";
      let A1, A2, A3, A4;

      A1 = this.arcPos(origin, baseline, startAngle);

      A2 = this.arcPos(origin, baseline, startAngle + sweep);

      let rotation = 0;
      let arcFlag = 0;
      let sweepFlag = 1;

      if(flip){
        A3 = A2;
        A4 = A1;
        A1 = A3;
        A2 = A4;


        //arcFlag = 1;
        sweepFlag = 0;
      }

      let d = "M"+A1.x + ","+A1.y;
      d += `A${baseline},${baseline} ${rotation} ${arcFlag},${sweepFlag} ${A2.x},${A2.y}`;
      return d;

    },
    arcPos: function(origin, radius, angle) {
      var radians = (Math.PI / 180) * angle;
      var posX = radius * Math.cos(radians) + origin.x;
      var posY = radius * Math.sin(radians) + origin.y;
      return {
        x: posX,
        y: posY
      }
    },
  },
  computed: {
    paths: function(){

      let origin = this.origin;
      let circumference = 360;
      let startAngle = parseFloat(this.startAngle);
      let innerRadius = parseFloat(this.innerRadius);
      let outerRadius = parseFloat(this.outerRadius);

      let textPaths = {}
      //let totalWeight = this.getTotalWeight(this.sections)

      let sliceDegreeSpan = circumference / this.sections.length;
      //let normalizedDegreeSpan = circumference / totalWeight; //weighted span by size

      let nodes = this.sections.map((category, catIndex)=>{
        let segmentStart = startAngle + (sliceDegreeSpan * catIndex); //what angle to start drawing path
        let textPosBias = 0.45; //distance between innner and outer radius
        let textPos= this.arcPos(origin, (innerRadius + (outerRadius - innerRadius) * textPosBias),(segmentStart + (sliceDegreeSpan/2)));
        //let cumulativeSpanDegrees = 0;
        let textPath = (this.sections.length > 1)?this.arc(origin, innerRadius, outerRadius-(category.labelFlip?0.8:0), segmentStart, sliceDegreeSpan, category.labelFlip):this.circlePathSingle(origin,innerRadius + ((outerRadius - innerRadius)*(category.textBias?category.textBias:0.5)),0); //for curved text

        //console.log("ringIndex",this.ringIndex)
        //console.log("catIndex",catIndex)
        let segmentPath = (this.sections.length > 1)?this.arcSlice(origin, innerRadius, outerRadius, segmentStart, sliceDegreeSpan):this.donutPath(origin, innerRadius, outerRadius, segmentStart, sliceDegreeSpan)

        return {
          id: category.id,
          d: segmentPath ,
          active: false,
          textPathId: `r${this.ringIndex}_c${catIndex}`,
          textPath: textPath,
          textPos: textPos,
          class: "level1",
          label: category.label,
          fill: this.fillColor,
          fontSize: this.fontSize,
          textDx: 0,
          textDy: 0
        }


      })

      return {
        nodes,
        textPaths
      }
    }
  }
}
</script>

<style scoped>
.slice path {
  stroke: var(--level2-stroke);
  transition: stroke, fill 0.3s
}

.slice text {
  pointer-events: none;
  user-select: none;
  fill: var(--level2-text);

  letter-spacing: 0.05em;
}

.slice .slice-path  {

  fill: var(--level2-fill);


}

.slice .segments .segment path {
  fill: var(--level3-fill);
}

.slice .segments .segment:hover path {
  fill: #777;
}

.slice .segments .segment text {
  fill: #fff;
}


.slice .segments .segment:hover text {

}






.slice[data-active="true"] .segments .segment[data-active="true"] path {
  fill: #888;
}

.bubbles .bubble {

  display: none;
  opacity: 0;
}


.segment .bubbles .bubble circle, .segment .bubbles .bubble line {
  fill: var(--level4-fill);
  stroke: var(--level4-stroke);

}

.segment .bubbles .bubble text {

  fill: var(--level4-text);

}



.segment[data-active="true"] .bubbles .bubble[data-active=true] circle {

  fill: var(--level4-fill-select);
  stroke: var(--level4-stroke-select);

}

.segment[data-active="true"] .bubbles .bubble[data-active=true] text {

  fill: var(--level4-text-select);

}


.slice[data-active="true"] .segment[data-active="true"] > text {



}

.segmented-ring[data-active="true"] .segment .tab {
  cursor: pointer;
  transition: 0.1s fill;
}

.segmented-ring[data-active="true"] .segment:hover .tab {
  fill: #555;
}

.segmented-ring[data-active="true"] .segment:hover .text {
  fill: #fff;
}

.segmented-ring[data-active="true"][data-fill="#ccc"] .segment:hover .tab {
  fill: #fff;
}

.segmented-ring[data-active="true"][data-fill="#ccc"] .segment:hover .text {
  fill: #000;
}

.segmented-ring[data-active="true"][data-fill="#CC0000"] .segment:hover .tab {
  fill: #ff2222;
}

.segmented-ring[data-active="true"][data-fill="#CC0000"] .segment:hover .text {
  fill: #fff;
}

.segmented-ring .segment[data-active="true"] .tab {
  fill: #fff;
}

.segmented-ring .segment[data-active="true"] .text {
  fill: #000;
}

 .sustainable-future .text{

}















</style>